module.exports = __webpack_public_path__ + "static/media/new-user.538e8510.png";